import { Component, h, Prop } from '@stencil/core';
import Icon from '../svg/xmark.svg'

@Component({
  tag: 'cr-icon-xmark',
  styleUrl: '../cr-icon.css',
  shadow: true,
})
export class CrIconXmark {

  /**
   * The size of the icon - can be 'small', 'medium' or 'large'
   */
  @Prop() size: string

  render() {
    return (
      <div
        class={this.size}
        innerHTML={Icon}
      />
    );
  }

}
